import { smartScrollIntoViewIfNeeded } from 'lib/window/scrollUtils'
import { getHeight } from 'lib/window/getViewport'
import { waitElement } from '../../client/lib/dom/waitElement'

export const scrollToNewItemWithRetry = async(itemId: string) => {
  const maxAttempts = 10
  const delay = 100
  const getNewItemElement = () => document.getElementById(`draggable-item-${itemId}`)

  waitElement(getNewItemElement, maxAttempts, delay).then(
    element => {
      const viewportHeight = getHeight()
      const elementHeight = element.getBoundingClientRect().height
      const centerOffset = (viewportHeight - elementHeight) / 2
      smartScrollIntoViewIfNeeded(element, centerOffset)
    }).catch(() => {})
}
